import { render, staticRenderFns } from "./DataSourceDump.vue?vue&type=template&id=5b8367ea&scoped=true&"
import script from "./DataSourceDump.vue?vue&type=script&lang=js&"
export * from "./DataSourceDump.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceDump.vue?vue&type=style&index=0&id=5b8367ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8367ea",
  null
  
)

export default component.exports